import React from 'react';

const EmployersHero: React.FC = () => {
    return (
        <section className="relative px-2 sm:px-4 pt-16 sm:pt-20 lg:pt-10 pb-10 sm:pb-10" style={{ minHeight: 'clamp(800px, 100vh, 1100px)' }}>
            <div className="container mx-auto max-w-[1640px] relative">
                {/* Main Title */}
                <h1
                    className="text-center mb-2 px-2 sm:px-0"
                    style={{
                        fontFamily: 'Manrope',
                        fontStyle: 'normal',
                        fontWeight: 700,
                        fontSize: 'clamp(32px, 8vw, 112px)',
                        lineHeight: '1.3',
                        letterSpacing: '-0.05em',
                        color: '#FFFFFF',
                        maxWidth: '100%',
                        margin: '0 auto 0px',
                    }}
                >
                    <span className="block sm:inline">Hire smarter.</span>
                    {' '}
                    <span className="block sm:inline">Hire faster.</span>
                </h1>

                {/* Glassmorphic Elements Container */}
                <div className="relative" style={{ height: 'clamp(500px, 80vh, 800px)', marginTop: 'clamp(20px, 4vh, 40px)' }}>
                    {/* Subtitle - positioned over the container */}
                    <p
                        className="text-center px-4"
                        style={{
                            position: 'absolute',
                            top: 'clamp(15%, 20%, 25%)',
                            left: '0',
                            right: '0',
                            fontFamily: 'Manrope',
                            fontStyle: 'normal',
                            fontWeight: 200,
                            fontSize: 'clamp(14px, 2vw, 28px)',
                            lineHeight: '1.4',
                            letterSpacing: '-0.02em',
                            color: '#FFFFFF',
                            maxWidth: '100%',
                            margin: '0 auto',
                            zIndex: 5
                        }}
                    >
                        Access top passive talent through AI-powered recruiting that delivers results.
                    </p>

                    {/* Blur Background Circles */}
                    <div
                        className="hidden sm:block"
                        style={{
                            position: 'absolute',
                            width: '1054px',
                            height: '1054px',
                            left: 'calc(50% - 1054px/2)',
                            top: 'calc(50% - 1054px/2)',
                            background: 'linear-gradient(135deg, #023D6A 0%, #3E5278 100%)',
                            filter: 'blur(100px)',
                            opacity: 0.4,
                            zIndex: 0
                        }}
                    />
                    <div
                        className="hidden sm:block"
                        style={{
                            position: 'absolute',
                            width: '807px',
                            height: '807px',
                            left: 'calc(50% - 807px/2 - 100px)',
                            top: 'calc(50% - 807px/2 + 60px)',
                            background: 'radial-gradient(50% 50% at 50% 50%, rgba(1, 95, 166, 0.5) 0%, rgba(31, 143, 255, 0) 100%)',
                            filter: 'blur(200px)',
                            opacity: 0.4,
                            zIndex: 0
                        }}
                    />
                    <div
                        className="block sm:hidden"
                        style={{
                            position: 'absolute',
                            width: '100%',
                            height: '100%',
                            left: '0',
                            top: '0',
                            background: 'radial-gradient(circle at center, rgba(1, 95, 166, 0.3) 0%, rgba(31, 143, 255, 0) 70%)',
                            filter: 'blur(80px)',
                            opacity: 0.6,
                            zIndex: 0
                        }}
                    />

                    {/* Main Product Card */}
                    <div
                        className="absolute"
                        style={{
                            left: 'clamp(5%, 19.5%, 19.5%)',
                            right: 'clamp(5%, 19.5%, 19.5%)',
                            top: 'clamp(8%, 5%, 5%)',
                            height: 'clamp(300px, 50vh, 600px)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            padding: '0px',
                            background: 'rgba(5, 5, 5, 0.9)',
                            mixBlendMode: 'screen',
                            border: '0.75px solid rgba(255, 255, 255, 0.5)',
                            boxShadow: '0px 3.75px 7.5px rgba(0, 0, 0, 0.05), 0px 11.25px 22.5px rgba(0, 0, 0, 0.05), 0px 22.5px 45px rgba(0, 0, 0, 0.1), inset 0px 37.5px 75px rgba(255, 255, 255, 0.15)',
                            backdropFilter: 'blur(7.5px)',
                            borderRadius: '22.5px',
                            zIndex: 2
                        }}
                    />

                    {/* Score Circle - Right (98) using SVG */}
                    <div
                        className="absolute"
                        style={{
                            right: 'clamp(2%, 12%, 12%)',
                            top: 'clamp(5%, 8%, 8%)',
                            width: 'clamp(120px, 20vw, 186px)',
                            height: 'clamp(125px, 20vw, 190px)',
                            zIndex: 4
                        }}
                    >
                        {/* Solid background matching SVG circle dimensions */}
                        <div
                            style={{
                                position: 'absolute',
                                left: '10.75%',
                                top: '5.26%',
                                width: '78.5%',
                                height: '78.95%',
                                background: 'radial-gradient(circle, rgba(2, 35, 52, 0.95) 0%, rgba(2, 35, 52, 0.85) 60%, rgba(2, 35, 52, 0.7) 100%)',
                                borderRadius: '50%',
                                zIndex: -1
                            }}
                        />
                        {/* Blur background circle */}
                        <div
                            style={{
                                position: 'absolute',
                                width: '220px',
                                height: '220px',
                                left: '-17px',
                                top: '-15px',
                                background: 'radial-gradient(circle, rgba(2, 35, 52, 0.6) 0%, rgba(2, 35, 52, 0.3) 70%, transparent 100%)',
                                filter: 'blur(20px)',
                                zIndex: -2
                            }}
                        />
                        <img
                            src="/progress/percent98.svg"
                            alt="98% score"
                            style={{
                                width: '100%',
                                height: '100%',
                                objectFit: 'contain'
                            }}
                        />
                    </div>

                    {/* Progress Ring - Left (50%) using SVG */}
                    <div
                        className="absolute"
                        style={{
                            left: 'clamp(2%, 12%, 12%)',
                            top: 'clamp(48%, 55%, 55%)',
                            width: 'clamp(110px, 18vw, 166px)',
                            height: 'clamp(115px, 19vw, 178px)',
                            zIndex: 4
                        }}
                    >
                        {/* Solid background matching SVG circle dimensions */}
                        <div
                            style={{
                                position: 'absolute',
                                left: '12%',
                                top: '4.5%',
                                width: '76%',
                                height: '79.8%',
                                background: 'radial-gradient(circle, rgba(2, 35, 52, 0.95) 0%, rgba(2, 35, 52, 0.85) 60%, rgba(2, 35, 52, 0.7) 100%)',
                                borderRadius: '50%',
                                zIndex: -1
                            }}
                        />
                        {/* Blur background circle */}
                        <div
                            style={{
                                position: 'absolute',
                                width: '200px',
                                height: '200px',
                                left: '-17px',
                                top: '-11px',
                                background: 'radial-gradient(circle, rgba(2, 35, 52, 0.6) 0%, rgba(2, 35, 52, 0.3) 70%, transparent 100%)',
                                filter: 'blur(20px)',
                                zIndex: -2
                            }}
                        />
                        <img
                            src="/progress/percent50.svg"
                            alt="50% progress"
                            style={{
                                width: '100%',
                                height: '100%',
                                objectFit: 'contain'
                            }}
                        />
                    </div>

                    {/* Main Card with Stacked Effect - Bottom Center using SVG */}
                    <div
                        className="absolute"
                        style={{
                            left: 'calc(50% - min(235px, 35vw))',
                            bottom: 'clamp(-20px, 4%, 4%)',
                            width: 'clamp(280px, 70vw, 470px)',
                            height: 'clamp(300px, 60vw, 500px)',
                            zIndex: 3
                        }}
                    >
                        {/* Solid background - matching SVG card dimensions */}
                        <div
                            style={{
                                position: 'absolute',
                                left: '12.8%',
                                top: '6%',
                                width: '74.4%',
                                height: '76%',
                                background: 'radial-gradient(ellipse at center, rgba(2, 35, 52, 0.95) 0%, rgba(2, 35, 52, 0.85) 60%, rgba(2, 35, 52, 0.7) 100%)',
                                borderRadius: '40px',
                                zIndex: -1
                            }}
                        />
                        <img
                            src="/progress/innerbox.svg"
                            alt="Stacked cards"
                            style={{
                                width: '100%',
                                height: '100%',
                                objectFit: 'contain'
                            }}
                        />
                    </div>
                </div>
            </div>
        </section>
    );
};

export default EmployersHero;
